export const topicSettings = {
  title: '',
  subtitle: '',
  buttonLabel: '',
  topics: [],
};
